import { Component, Input, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { OrderComponent } from '../order/order.component';
import { MatBadgeModule } from '@angular/material/badge';

const materialModules = [
  MatIconModule,
  MatButtonModule,
  MatBadgeModule
]

const components = [
  OrderComponent
]

@Component({
  selector: 'app-locker-orders',
  templateUrl: './orders.component.html',
  styleUrls: ['./orders.component.scss'],
  standalone: true,
  imports: [
    TranslateModule, ...materialModules, ...components
  ]
})
export class OrdersComponent  implements OnInit {

  @Input() orders: any[] = [];
  @Input() menu: any;

  pendingCollapsed: boolean = true;
  paidCollapsed: boolean = true;
  deliveredCollapsed: boolean = true;
  cancelledCollapsed: boolean = true;

  constructor() { }

  ngOnInit(): void {}

  get pendingOrders() {
    return this.orders.filter(o => o.status === 'pending');
  }

  get paidOrders() {
    return this.orders.filter(o => o.status === 'paid');
  }

  get deliveredOrders() {
    return this.orders.filter(o => o.status === 'delivered');
  }

  get cancelledOrders() {
    return this.orders.filter(o => o.status === 'cancelled');
  }

}
